(function () {
    var SESSION_KEY = '__pvt_fmk';
    var HKDF_INFO = 'schlorf.at family archive wrapping key v1';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function addPrivateLinkIcons() {
        var pvtUrls = window.__pvtUrls;
        if (!pvtUrls || !pvtUrls.length) return;
        var links = document.querySelectorAll('a[href]');
        for (var i = 0; i < links.length; i++) {
            try {
                var url = new URL(links[i].getAttribute('href'), window.location.origin);
                if (url.hostname === window.location.hostname && pvtUrls.indexOf(url.pathname) !== -1) {
                    if (!links[i].querySelector('.pvt-link-lock')) {
                        var icon = document.createElement('span');
                        icon.className = 'pvt-link-lock';
                        icon.setAttribute('aria-hidden', 'true');
                        links[i].appendChild(icon);
                    }
                }
            } catch (e) {}
        }
    }

    async function init() {
        // Alte localStorage-Daten entfernen (Migration von V1)
        try { localStorage.removeItem('__pvt_passkey'); } catch (_) {}

        addPrivateLinkIcons();

        var blocks = document.querySelectorAll('.private-block');
        if (!blocks.length) return;

        var storedFmk = tryGetStoredFmk();
        if (storedFmk) {
            await decryptAll(blocks, storedFmk);
            return;
        }

        var pvtPasskeys = window.__pvtPasskeys || [];
        if (pvtPasskeys.length > 0) {
            await autoTryPasskey(blocks, pvtPasskeys);
            return;
        }

        for (var i = 0; i < blocks.length; i++) {
            showUnlockUI(blocks[i]);
        }
    }

    function tryGetStoredFmk() {
        try {
            var k = sessionStorage.getItem(SESSION_KEY);
            return k ? JSON.parse(k) : null;
        } catch (e) { return null; }
    }

    function storeFmk(fmkData) {
        try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(fmkData)); } catch (e) {}
    }

    async function decryptAll(blocks, fmkData) {
        var fmk = await importFmk(new Uint8Array(fmkData));
        for (var i = 0; i < blocks.length; i++) {
            await decryptBlock(blocks[i], fmk);
        }
    }

    async function importFmk(fmkBytes) {
        return crypto.subtle.importKey('raw', fmkBytes, 'AES-GCM', false, ['decrypt']);
    }

    async function decryptBlock(block, fmk) {
        var ivB64 = block.dataset.iv;
        var ctB64 = block.dataset.ct;
        if (!ivB64 || !ctB64) return;
        var iv = base64ToBytes(ivB64);
        var ct = base64ToBytes(ctB64);
        try {
            var decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, fmk, ct);
            block.innerHTML = new TextDecoder().decode(decrypted);
            block.classList.add('private-block--unlocked');
            await decryptImages(block, fmk);
        } catch (e) {
            var txt = block.querySelector('.private-placeholder-text');
            if (txt) txt.textContent = 'Entschlüsselung fehlgeschlagen';
        }
    }

    async function decryptImages(container, fmk) {
        var imgs = container.querySelectorAll('img[src]');
        for (var i = 0; i < imgs.length; i++) {
            var img = imgs[i];
            var src = img.getAttribute('src');
            if (!src || !src.endsWith('.enc')) continue;
            try {
                var resp = await fetch(src);
                if (!resp.ok) throw new Error('fetch failed');
                var encJson = await resp.json();
                var iv = base64ToBytes(encJson.iv);
                var ct = base64ToBytes(encJson.ct);
                var plain = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: iv }, fmk, ct);
                var bytes = new Uint8Array(plain);
                var mime = bytes[0] === 0xFF && bytes[1] === 0xD8 ? 'image/jpeg'
                    : bytes[0] === 0x89 && bytes[1] === 0x50 ? 'image/png'
                    : 'image/jpeg';
                img.src = URL.createObjectURL(new Blob([plain], { type: mime }));
                var article = img.closest('article');
                var permalink = article && article.querySelector('.feed-post-permalink');
                if (permalink && img.parentElement && img.parentElement.tagName !== 'A') {
                    var link = document.createElement('a');
                    link.href = permalink.href;
                    img.parentNode.insertBefore(link, img);
                    link.appendChild(img);
                }
            } catch (e) {
                img.alt = 'Bild konnte nicht geladen werden';
            }
        }
    }

    function showUnlockUI(block) {
        var placeholder = block.querySelector('.private-placeholder');
        if (!placeholder) return;
        placeholder.style.cursor = 'pointer';
        placeholder.addEventListener('click', function () { showUnlockDialog(); });
        var btn = document.createElement('button');
        btn.className = 'private-unlock-btn';
        btn.textContent = 'Entsperren';
        btn.addEventListener('click', function (e) { e.stopPropagation(); showUnlockDialog(); });
        placeholder.appendChild(btn);
    }

    function showUnlockDialog() {
        if (document.querySelector('.private-modal')) return;

        var pvtPasskeys = window.__pvtPasskeys || [];
        var hasPasskeys = pvtPasskeys.length > 0;

        var modal = document.createElement('div');
        modal.className = 'private-modal';
        modal.innerHTML =
            '<div class="private-modal-inner">' +
            '<button class="private-modal-close" id="pvt-close">✕</button>' +
            '<h3 class="private-modal-title">🔒 Privater Inhalt</h3>' +
            (hasPasskeys ? '<button class="private-btn private-btn--passkey" id="pvt-passkey-btn">Face ID / Passkey</button>' : '') +
            '<p class="private-error" id="pvt-error" hidden></p>' +
            '<p class="private-reset"><a href="#" id="pvt-recovery-link">Recovery Key verwenden</a></p>' +
            '</div>';

        document.body.appendChild(modal);
        setTimeout(function () { modal.classList.add('private-modal--visible'); }, 10);

        document.getElementById('pvt-close').addEventListener('click', function () { closeModal(modal); });
        modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });

        document.getElementById('pvt-recovery-link').addEventListener('click', function (e) {
            e.preventDefault();
            showRecoveryDialog(modal);
        });

        if (hasPasskeys) {
            document.getElementById('pvt-passkey-btn').addEventListener('click', function () { tryPasskey(modal); });
            // Auto-trigger passkey when dialog opens
            setTimeout(function () { tryPasskey(modal); }, 300);
        }
    }

    function showRecoveryDialog(parentModal) {
        closeModal(parentModal);
        setTimeout(function () {
            if (document.querySelector('.private-modal')) return;
            var modal = document.createElement('div');
            modal.className = 'private-modal';
            modal.innerHTML =
                '<div class="private-modal-inner">' +
                '<button class="private-modal-close" id="pvt-close">✕</button>' +
                '<h3 class="private-modal-title">🔑 Recovery Key</h3>' +
                '<p style="font-size:0.82rem;color:rgba(255,255,255,0.45);margin:0 0 0.5rem">Recovery Key (Base64) eingeben:</p>' +
                '<input type="text" class="private-password-input" placeholder="Base64 Recovery Key…" id="pvt-recovery-input" autocomplete="off" style="font-family:monospace;font-size:0.8rem;">' +
                '<button class="private-btn" id="pvt-recovery-btn">Entsperren</button>' +
                '<p class="private-error" id="pvt-error" hidden></p>' +
                '</div>';
            document.body.appendChild(modal);
            setTimeout(function () { modal.classList.add('private-modal--visible'); }, 10);
            document.getElementById('pvt-close').addEventListener('click', function () { closeModal(modal); });
            modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });
            document.getElementById('pvt-recovery-btn').addEventListener('click', function () { tryRecoveryKey(modal); });
            document.getElementById('pvt-recovery-input').addEventListener('keydown', function (e) {
                if (e.key === 'Enter') tryRecoveryKey(modal);
            });
            setTimeout(function () { document.getElementById('pvt-recovery-input').focus(); }, 100);
        }, 220);
    }

    async function tryRecoveryKey(modal) {
        var input = document.getElementById('pvt-recovery-input');
        var value = input ? input.value.trim() : '';
        if (!value) return;
        setLoading(modal, true);
        hideError(modal);
        try {
            var recoveryKeyBytes = base64ToBytes(value);
            if (recoveryKeyBytes.length !== 32) throw new Error('Ungültige Länge (32 Bytes erwartet)');

            var recoveryKey = await crypto.subtle.importKey('raw', recoveryKeyBytes, 'AES-GCM', false, ['decrypt']);
            var wrapped = window.__pvtRecoveryWrappedFmk;
            if (!wrapped) throw new Error('Kein Recovery-Wrapping gefunden');

            var fmkBytes = await crypto.subtle.decrypt(
                { name: 'AES-GCM', iv: base64ToBytes(wrapped.iv) },
                recoveryKey,
                base64ToBytes(wrapped.ct)
            );

            var fmkData = Array.from(new Uint8Array(fmkBytes));
            var blocks = document.querySelectorAll('.private-block');
            if (blocks.length) {
                var fmk = await importFmk(new Uint8Array(fmkData));
                await verifyFmk(blocks[0], fmk);
            }

            storeFmk(fmkData);
            closeModal(modal);
            await decryptAll(blocks, fmkData);
            showToast('Recovery Key akzeptiert. Bitte neuen Passkey unter /pvt-setup/ einrichten.');
        } catch (e) {
            showError(modal, 'Ungültiger Recovery Key');
            setLoading(modal, false);
        }
    }

    function closeModal(modal) {
        modal.classList.remove('private-modal--visible');
        setTimeout(function () { modal.remove(); }, 200);
    }

    // ── Passkey flow ───────────────────────────────────────────────────────────

    async function autoTryPasskey(blocks, pvtPasskeys) {
        try {
            var fmkData = await passkeyGetFmk(pvtPasskeys);
            storeFmk(fmkData);
            await decryptAll(blocks, fmkData);
        } catch (e) {
            for (var i = 0; i < blocks.length; i++) {
                showUnlockUI(blocks[i]);
            }
        }
    }

    async function tryPasskey(modal) {
        try {
            setLoading(modal, true);
            hideError(modal);
            var pvtPasskeys = window.__pvtPasskeys || [];
            var fmkData = await passkeyGetFmk(pvtPasskeys);
            storeFmk(fmkData);
            closeModal(modal);
            var blocks = document.querySelectorAll('.private-block');
            await decryptAll(blocks, fmkData);
        } catch (e) {
            showError(modal, 'Face ID fehlgeschlagen');
            setLoading(modal, false);
        }
    }

    async function passkeyGetFmk(pvtPasskeys) {
        var evalByCredential = {};
        var allowCredentials = [];
        for (var i = 0; i < pvtPasskeys.length; i++) {
            var entry = pvtPasskeys[i];
            var credIdBytes = base64ToBytes(entry.credentialId);
            allowCredentials.push({ type: 'public-key', id: credIdBytes });
            evalByCredential[bytesToBase64url(credIdBytes)] = { first: base64ToBytes(entry.prfSalt) };
        }

        var assertion = await navigator.credentials.get({
            publicKey: {
                challenge: crypto.getRandomValues(new Uint8Array(32)),
                rpId: window.location.hostname,
                allowCredentials: allowCredentials,
                userVerification: 'required',
                extensions: { prf: { evalByCredential: evalByCredential } }
            }
        });

        var prfResult = assertion.getClientExtensionResults().prf;
        var prfOutput = prfResult && prfResult.results && prfResult.results.first;
        if (!prfOutput) throw new Error('PRF nicht verfügbar');

        var returnedCredIdB64 = bytesToBase64(new Uint8Array(assertion.rawId));
        var matchedEntry = null;
        for (var j = 0; j < pvtPasskeys.length; j++) {
            if (pvtPasskeys[j].credentialId === returnedCredIdB64) {
                matchedEntry = pvtPasskeys[j];
                break;
            }
        }
        if (!matchedEntry) throw new Error('Credential nicht gefunden');

        var wrapKey = await hkdfDeriveKey(prfOutput, base64ToBytes(matchedEntry.hkdfSalt));
        var fmkBytes = await crypto.subtle.decrypt(
            { name: 'AES-GCM', iv: base64ToBytes(matchedEntry.wrappedFmk.iv) },
            wrapKey,
            base64ToBytes(matchedEntry.wrappedFmk.ct)
        );
        return Array.from(new Uint8Array(fmkBytes));
    }

    async function verifyFmk(block, fmk) {
        var ivB64 = block.dataset.iv;
        var ctB64 = block.dataset.ct;
        if (!ivB64 || !ctB64) return;
        await crypto.subtle.decrypt({ name: 'AES-GCM', iv: base64ToBytes(ivB64) }, fmk, base64ToBytes(ctB64));
    }

    // HKDF: PRF output + per-credential salt → deterministic wrapping key
    async function hkdfDeriveKey(prfOutput, hkdfSaltBytes) {
        var ikm = await crypto.subtle.importKey('raw', prfOutput, 'HKDF', false, ['deriveKey']);
        return crypto.subtle.deriveKey(
            { name: 'HKDF', hash: 'SHA-256', salt: hkdfSaltBytes, info: new TextEncoder().encode(HKDF_INFO) },
            ikm,
            { name: 'AES-GCM', length: 256 },
            false,
            ['encrypt', 'decrypt']
        );
    }

    // ── UI helpers ─────────────────────────────────────────────────────────────

    function showError(modal, msg) {
        var err = document.getElementById('pvt-error');
        if (err) { err.textContent = msg; err.hidden = false; }
    }

    function hideError(modal) {
        var err = document.getElementById('pvt-error');
        if (err) err.hidden = true;
    }

    function setLoading(modal, loading) {
        ['pvt-passkey-btn', 'pvt-recovery-btn'].forEach(function (id) {
            var btn = document.getElementById(id);
            if (btn) btn.disabled = loading;
        });
    }

    function showToast(msg) {
        var t = document.createElement('div');
        t.className = 'private-toast';
        t.textContent = msg;
        document.body.appendChild(t);
        setTimeout(function () { t.classList.add('private-toast--visible'); }, 10);
        setTimeout(function () { t.classList.remove('private-toast--visible'); setTimeout(function () { t.remove(); }, 300); }, 4000);
    }

    function base64ToBytes(b64) {
        var bin = atob(b64);
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        return bytes;
    }

    function bytesToBase64(bytes) {
        var bin = '';
        for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
        return btoa(bin);
    }

    function bytesToBase64url(bytes) {
        return bytesToBase64(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
})();
